export type TicketStatusKey =
  | 'unassigned'
  | 'active'
  | 'paid'
  | 'appeal_pending'
  | 'appeal_won'
  | 'appeal_lost'
  | 'appeal_rejected'
  | 'transferred'
  | 'cancelled'
  | 'unknown';

export const normalizeTicketStatus = (raw: unknown): TicketStatusKey => {
  const s = String(raw ?? '').trim();
  if (!s) return 'unknown';
  const key = s.toLowerCase().replace(/\s+/g, '_');

  switch (key) {
    case 'unassigned':
    case 'active':
    case 'open':
    case 'paid':
    case 'appeal_pending':
    case 'appeal_won':
    case 'appeal_lost':
    case 'appeal_rejected':
    case 'transferred':
    case 'cancelled':
      return key === 'open' ? 'active' : key;
    // Common variants
    case 'appeal':
    case 'appealing':
      return 'appeal_pending';
    case 'paid_in_full':
      return 'paid';
    default:
      return 'unknown';
  }
};

export const formatTicketStatus = (raw: unknown): string => {
  const key = normalizeTicketStatus(raw);
  switch (key) {
    case 'unassigned':
      return 'Unassigned';
    case 'active':
      return 'Active';
    case 'paid':
      return 'Paid';
    case 'appeal_pending':
      return 'Appeal Pending';
    case 'appeal_won':
      return 'Appeal Won';
    case 'appeal_lost':
      return 'Appeal Lost';
    case 'appeal_rejected':
      return 'Appeal Rejected';
    case 'transferred':
      return 'Transferred';
    case 'cancelled':
      return 'Cancelled';
    default:
      return String(raw ?? 'Unknown') || 'Unknown';
  }
};

export const isTerminalTicketStatus = (raw: unknown): boolean => {
  const key = normalizeTicketStatus(raw);
  return key === 'paid' || key === 'transferred' || key === 'cancelled' || key === 'appeal_won' || key === 'appeal_lost';
};
